import { GET, POST, GETWithoutRedirect, POSTWithoutRedirect } from "../API";
let source = null;

export const getCurrentUserApi = (onSuccess, onError) => {
  source = GET(
    `/api/v1/identity/users/current`,
    onSuccess,
    onError,
    true,
    source
  );
};

export const getCurrentUserAPINoRedirectCall = (onSuccess, onError) => {
  source = GETWithoutRedirect(
    `/api/v1/identity/users/current`,
    onSuccess,
    onError,
    true,
    source
  );
};

export const getCustomTokenAPICall = (onSuccess, onError) => {
  GETWithoutRedirect(
    `/api/v1/identity/users/authentication_token`,
    onSuccess,
    onError
  );
};

export const loginWithSSOAPICall = (tokenOnly = false, onSuccess, onError) => {
  const data = {};
  let URL = "/api/v1/identity/sso/auth/microsoft_office365";
  if (tokenOnly) {
    URL = URL + "?token_only=true";
  }

  POST(URL, data, onSuccess, onError);
};

export const loginWithGoogleAPICall = (
  tokenOnly = false,
  onSuccess,
  onError
) => {
  const data = {};
  let URL = "/api/v1/identity/sso/auth/google_oauth2";
  if (tokenOnly) {
    URL = URL + "?token_only=true";
  }

  POST(URL, data, onSuccess, onError);
};

export const getPlatformSubscriptionAPICall = (onSuccess, onError) => {
  GET(`/api/v1/identity/users/platform_subscription`, onSuccess, onError);
};

export const getProductQuotaAPICall = (productSlug, projectId, onSuccess, onError) => {
  const params = new URLSearchParams({ product_slug: productSlug });
  if (projectId) params.append("api_project_id", projectId);
  GET(`/api/v1/identity/users/product_quota?${params}`, onSuccess, onError);
};

export const canLinkAPICall = (dataObject, onSuccess, onError) => {
  const data = dataObject
  POST(`/api/v1/identity/users/can_link`, data, onSuccess, onError);
};

export const linkPhoneNumberAPICall = (token, onSuccess, onError) => {
  const data = {
    token: token
  }
  POST(`/api/v1/identity/users/link_phone_number`, data, onSuccess, onError);
};

export const linkEmailAPICall = (code, email, onSuccess, onError) => {
  const data = {
    code: code,
    email: email
  }
  POSTWithoutRedirect(`/api/v1/identity/users/link_email`, data, onSuccess, onError);
};

export const authenticateEmailAPICall = (email, onSuccess, onError) => {
  const data = {
    email: email
  }
  POST(`/api/v1/identity/users/authenticate_email`, data, onSuccess, onError);
};

export const setLinkedEmailPasswordAPICall = (password, onSuccess, onError) =>
  POSTWithoutRedirect(`/api/v1/identity/users/set_linked_email_password`, { password }, onSuccess, onError);
